import { render } from "./X3.vue?vue&type=template&id=715132fa"
import script from "./X3.vue?vue&type=script&lang=js"
export * from "./X3.vue?vue&type=script&lang=js"

import "./X3.vue?vue&type=style&index=0&id=715132fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__